/*global $, document, window, _etTimemut, alert, FG */
(function () {
    "use strict";
    FG.Label = {
        oddcolor: '',
        evencolor: '',

        init: function () {
            this.initEventFilter();
            this.initDateFilter();
            this.initDateClick();
            this.initColors();
            this.initEventCategories();
            this.initParseHash();
            this.bannerResize();
        },

        /**
        * Dynamically styles newsflash banner based on banner height
        * for mobile styling and window resizing 
        */
        bannerResize: function(){
            var ribbonHeight = $('.color-ribbonbackground').outerHeight();
            var ribbonBorderTopBottom = (ribbonHeight * .5) + "px";
            var ribbonBorderLeftRight= (ribbonHeight * .4) + "px";

            $('.ribbon-before').css({
                    'border-left-width': ribbonBorderLeftRight,
                    'border-top-width': ribbonBorderTopBottom,
                    'border-bottom-width': ribbonBorderTopBottom
                });

             $('.ribbon-after').css({
                    'border-right-width': ribbonBorderLeftRight,
                    'border-top-width': ribbonBorderTopBottom,
                    'border-bottom-width': ribbonBorderTopBottom
                });

             $(window).resize(function(){
                var resizeRibbonHeight = $('.color-ribbonbackground').outerHeight()

                if (ribbonHeight!=resizeRibbonHeight){
                    ribbonHeight = resizeRibbonHeight
                    var ribbonBorderTopBottom = (ribbonHeight * .5) + "px";
                    var ribbonBorderLeftRight= (ribbonHeight * .4) + "px";

                    $('.ribbon-before').css({
                        'border-left-width': ribbonBorderLeftRight,
                        'border-top-width': ribbonBorderTopBottom,
                        'border-bottom-width': ribbonBorderTopBottom
                    });

                    $('.ribbon-after').css({
                        'border-right-width': ribbonBorderLeftRight,
                        'border-top-width': ribbonBorderTopBottom,
                        'border-bottom-width': ribbonBorderTopBottom
                    }); 
                }  
            })
        },
        
        initColors: function() {
            this.oddcolor = $('div.label-event:odd').css('background-color');
            this.evencolor = $('div.label-event:even').css('background-color');
        },

        initEventCategories: function() {
            var validnav = [];
            /**  
             * Gather a list of event categories displayed on the page 
             */
            $("div[class*='eventcat_']").each(function() {
                validnav.push("#" + $(this).attr("class").match(/\beventcat_.*\b/)[0]);
            });
            $(validnav.join()).addClass("valid");
            /**
             * Remove categories with no events associated 
             * so you don't have empty navigation categories displayed
             */ 
            $("#eventCategories a[class!=valid]:not(.show-all)").remove();

            if ($("#eventCategories a:not(.show-all)").length == 0) {
                $("#eventCategories").hide();
            }

            $('.show-all').click(function(){
                $("div.label-event").show();
                $('#eventCategories a').removeClass('active');
                document.location.hash = '';
            })

            $("#eventCategories a:not(.show-all)").each(function() {
                // Make middle click and open link in new window work correctly
                $(this).attr("href", document.location.pathname +"#"+ $(this).attr("id").replace("eventcat_", ""));
                $(this).click(function() {
                    if (!$(this).hasClass("active")) {
                        $("div.label-event").hide();
                        $("." + this.id).show();
                        $("#eventCategories a").removeClass("active");
                        $("#eventCategoriesChildren a[parent_id!=" + $(this).attr("parent_id") + "]").hide();
                        $("#eventCategoriesChildren a[parent_id=" + $(this).attr("category_id") + "]").each(function(){
                            $("." + this.id).show();
                        }).show();
                        $(this).addClass("active");
                        document.location.hash = $(this).attr("href").split("#")[1];
                    }
                    else {
                        $("#eventCategoriesChildren a[parent_id!=" + $(this).attr("parent_id") + "]").hide();
                        if (typeof $(this).attr("parent_id") != "undefined"){
                            $("#eventCategoriesChildren a[parent_id=" + $(this).attr("parent_id") + "]").hide();
                        }
                        $("div.label-event").show();
                        $("#eventCategories a").removeClass("active");
                        document.location.hash = '';
                    }
                    FG.Label.reStripe();
                    return false;
                });
            });
        },

        initParseHash: function() {
            var hash = document.location.hash.replace(/^\#/, "");
            // If this is a child category show this and any sibling elements with the same parent
            if (typeof $("#eventcat_" + hash).attr("parent_id") != "undefined") {
                $("#eventCategoriesChildren a[parent_id=" + $("#eventcat_" + hash).attr("parent_id") + "]").show();
            }
            $("#eventcat_" + hash).click();
        },

        reStripe: function() {
            // Reapply the colors set in CSS based on the new flow caused by some filter
            $('div.label-event:visible:odd').css('background-color', this.oddcolor);
            $('div.label-event:visible:even').css('background-color', this.evencolor);
        },

        initDateClick: function () {
            $('time').click(function () {
                location.href = $(this).data('href');
            });
        },

        initEventFilter: function () {
            var $eventFilterButton = $('#event_filter button'),
                $labelEventDiv = $('div.label-event');
            //$('#event_filter input').keyup(function () {

	    $eventFilterButton.on('click keyup', function(e){
		if(e.type == 'click' || (e.which == '13' || e.which == '32')){
			e.preventDefault();
			e.stopPropagation();
			$('#event_filter').submit();
		}
	    });

	    $('#event_filter').submit(function(e){

                var filter = $(this).find('input').val().toLowerCase();//this.value.toLowerCase();
                if (filter) {
                    $('div.subhead').hide();
                }
                $labelEventDiv.find("span.filter:not(:contains(" + filter + "))").parent().hide();
                $labelEventDiv.find("span.filter:contains(" + filter + ")").each(function () {
                    $(this).parent().show().prevAll('div.subhead').first().show();
                });
                FG.Label.reStripe();
            });
        },

        applyDateFilter: function (start, end) {
            var self = this,
                shown_count = 0,
                evs = 'events',
                s,
                e,
                start_display,
                end_display;

            $('div.subhead').hide();

            $('div.label-event').find("span.datefilter").filter(function (index) {
                return parseInt($(this).text(), 10) < start;
            }).parent().hide();

            $('div.label-event').find("span.datefilter").filter(function (index) {
                return parseInt($(this).text(), 10) > end;
            }).parent().hide();

            $('div.label-event').find("span.datefilter").filter(function (index) {
                return (parseInt($(this).text(), 10) <= end && parseInt($(this).text(), 10) >= start);
            }).each(function () {
                shown_count += 1;
                $(this).parent().show().prevAll('div.subhead').first().show();
            });

            if (shown_count == 1) {
                evs = 'event';
            }
            s = new Date(start * 1000);
            e = new Date(end * 1000);

            start_display = (s.getMonth() < 10 ? '0' + s.getMonth() : s.getMonth());
            start_display += '/' + (s.getDate() < 10 ? '0' + s.getDate() : s.getDate());
            start_display += '/' + s.getFullYear();

            end_display = (e.getMonth() < 10 ? '0' + e.getMonth() : e.getMonth());
            end_display += '/' + (e.getDate() < 10 ? '0' + e.getDate() : e.getDate());
            end_display += '/' + e.getFullYear();

            if (start && end < 9999999999) {
                $('#filter_msg').html("Showing " + shown_count + " " + evs + " from " + start_display + " until " + end_display + " <a href='#' id='clear_date_filter'>show all</a>").show();
            } else {
                $('#filter_msg').html("Showing " + shown_count + " " + evs + " from " + start_display + " <a href='#' id='clear_date_filter'>show all</a>").show();
            }
            $('#clear_date_filter').click(function () {
                $('#dp_from').val('');
                $('#dp_to').val('');
                self.applyDateFilter(0, 9999999999);
                $('#filter_msg').html('').hide();
                return false;
            });
        },

        initDateFilter: function () {
            var self = this,
                start = 0,
                end = 9999999999;

            $('#dp_from').datepicker().on('changeDate', function (ev) {
                start = ev.date.valueOf() / 1000;
                $('#dp_to').focus();
            });
            $('#dp_to').datepicker().on('changeDate', function (ev) {
                end = ev.date.valueOf() / 1000;
                //$('#date_filter_form').submit();
            });
            $('#date_filter_form').submit(function (e) {
                self.applyDateFilter(start, end);
                return false;
            });
        },
    };
}());
